import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";

// Estados: draft (borrador) | in_transit (despachada) | partial (recepción parcial) | received | cancelled.
export const stockTransferStatus = v.union(
  v.literal("draft"),
  v.literal("in_transit"),
  v.literal("partial"),
  v.literal("received"),
  v.literal("cancelled"),
);

export const validatorStockTransfer = v.object({
  code: v.optional(v.string()),
  // Opcionales en borrador; obligatorias al despachar.
  fromWarehouseId: v.optional(v.id("warehouses")),
  toWarehouseId: v.optional(v.id("warehouses")),
  // Denormalizadas para filtros y display. Seteadas por el server al elegir bodega.
  fromBranchId: v.optional(v.id("branches")),
  toBranchId: v.optional(v.id("branches")),
  status: stockTransferStatus,

  transferDate: v.number(),
  dispatchedDate: v.optional(v.number()),
  receivedDate: v.optional(v.number()),

  notes: v.optional(v.string()),

  cancelReason: v.optional(v.string()),
  cancelDate: v.optional(v.number()),

  internalControl,
});

export const stock_transfers = defineTable(validatorStockTransfer)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_from_branch", ["fromBranchId"])
  .index("by_to_branch", ["toBranchId"])
  .index("by_status", ["status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_state", ["internalControl.state"])
  .index("by_created_at", ["internalControl.createdAt"]);
